import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowblockNS = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M12 3l5 5h-4.25v8H17l-5 5-5-5h4.245l.002-4-.002-4H7l5-5z" id="path-1"></path>
  </SvgIcon>
);

export default ArrowblockNS;
